"use client"

import { useEffect, useState } from "react"

import PreviewBanner from "./PreviewBanner"

export default function PreviewBannerWrapper() {
  const [isPreview, setIsPreview] = useState(false)

  useEffect(() => {
    // Check if we're in preview mode by looking at cookies
    const checkPreviewMode = () => {
      if (typeof document !== "undefined") {
        const cookies = document.cookie.split(";")
        const hasPreviewBypass = cookies.some((cookie) =>
          cookie.trim().startsWith("__prerender_bypass=")
        )
        const hasPreviewData = cookies.some((cookie) =>
          cookie.trim().startsWith("__next_preview_data=")
        )

        const previewMode = hasPreviewBypass && hasPreviewData
        setIsPreview(previewMode)

        // Adjust main content margin based on preview mode
        const mainElement = document.querySelector("main")
        if (mainElement) {
          mainElement.style.marginTop = previewMode ? "48px" : "0"
        }
      }
    }

    checkPreviewMode()

    // Check again when cookies change (e.g., when entering/exiting preview)
    const interval = setInterval(checkPreviewMode, 1000)

    return () => clearInterval(interval)
  }, [])

  if (!isPreview) {
    return null
  }

  return <PreviewBanner />
}
